import { gql } from '@apollo/client';

export const GetOngoingParkingSessionQuery = gql`
  query GetOngoingParkingSession {
    getOngoingParkingSession {
      id
      endedAt
      startedAt
      parking {
        id
        referenceParking {
          id
          bookings {
            id
            startsAt
            endsAt
            gate {
              id
            }
            user {
              id
            }
          }
        }
        bookings {
          id
          startsAt
          endsAt
          gate {
            id
          }
          user {
            id
          }
        }
      }
      gate {
        id
      }
      user {
        id
      }
    }
  }
`;
